import * as React from 'react'
import { connect } from "react-redux";

import {
    State
} from "../../types";
import {fetchViolationsHistory, sendViolationDetail} from "../../actions";
import { BlankSlate } from "./BlankSlate";
import { Loading } from "./Loading";
import Data from "./Data";
import "./violationsHistoryListStyle.css";
import {Violation} from "../../types";
import {getSelectedItemId, getViolationListType, setSelectedItemId} from "../../utils";

interface IState {
    Selecteditem: string
    backgroundColor: string,
    itemId: string
}

type Props = {
    violationsHistory: {},
    recentViolations: Violation[],
    violationDateKeys: string[],
    // violationDetailType: string,
    violationsListType: string,
    id: string,
    hasError: boolean,
    isLoading: boolean,
    dispatch: Function
}

export const ViolationsHistoryList = connect((state: State, ownProps: any) => {
    const currentViolationListType = getViolationListType();
    const selectedItemId = getSelectedItemId();

    let recentViolations: Violation[];
    let violationsHistory: {};

    let hasError = false;
    let isLoading = false;

    if (currentViolationListType === 'recent') {
        const recentViolationsState = state.dashboard.recentViolations;
        recentViolations = recentViolationsState && recentViolationsState.recentViolationsArray;
        violationsHistory = recentViolationsState && recentViolationsState.violationsHistory;
    } else {
        const violations = state.violationHistory.violations;
        recentViolations = violations.recentViolationsArray;
        violationsHistory = violations.violationsHistory;
        hasError = violations.hasError;
        isLoading = violations.isLoading;
    }

    const violationDateKeys = violationsHistory && Object.keys(violationsHistory).reverse();

    return {
        violationsHistory,
        recentViolations,
        violationDateKeys,
        violationsListType: currentViolationListType,
        id: selectedItemId,
        hasError,
        isLoading
    }
})
(class ViolationsHistory extends React.Component<Props, IState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            Selecteditem: '',
            backgroundColor: '',
            itemId: ''
        };

        this.viewSelectedViolation = this.viewSelectedViolation.bind(this)
    }

    componentDidMount() {
        const { dispatch, violationsListType } = this.props;
        if (!violationsListType || violationsListType !== 'recent') {
            dispatch(fetchViolationsHistory());
        }
    }

    // timeFilterChanged(event: any): void {
    //     console.log("here", event.target.value)
    // }

    async viewSelectedViolation(itemId: any,e:any) {
        // e.currentTarget.style = {background:'black'};

        await this.setState({
            itemId
        });
        const { dispatch, violationsListType } = this.props;

        setSelectedItemId(itemId);
        if (violationsListType === 'recent') {
            // dispatch(sendViolationDetail('', ''));
            dispatch(sendViolationDetail(itemId, 'recent'));
        } else {
            dispatch(sendViolationDetail(itemId, 'history'));
        }


        // this.setState({
        //     backgroundColor: '#000000'
        // });

    }


    render() {
        const { hasError, isLoading, violationsHistory, violationDateKeys } = this.props;
        let { id } = this.props;

        if (!id) {
            id = this.state.itemId;
        }

        if (isLoading) {
            return <Loading />
        }

        if (hasError || !violationDateKeys ||    violationDateKeys.length === 0) {
            return <BlankSlate />
        }

        return (
        
            <Data
                violationsHistory={violationsHistory}
                violationDateKeys={violationDateKeys}
                viewSelectedViolation={this.viewSelectedViolation}
                selectedItemId={id}
            />
        )
    }
});


// WEBPACK FOOTER //
// ./src/components/ViolationsHistoryList/ViolationsHistoryList.tsx